import Vue from 'vue'
import Router from 'vue-router'
import index from './../views/index'
import ranking from './../views/ranking'
import search from './../views/search'
import dapp from './../views/dapp'
// import submit from '../views/submit'
import about from '../views/about'
// import test from '../views/test'
import * as constants from '../const'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/test',
    //   name: 'test',
    //   component: test
    // },
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/dapp/:dapp',
      name: 'dapp',
      component: dapp
    },
    {
      path: '/ranking',
      name: 'ranking',
      component: ranking
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    // {
    //   path: '/submit',
    //   name: 'submit',
    //   component: submit
    // },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
export default router

function currentRoute () {
  return router.currentRoute
}

export function navigateToCategory (category) {
  router.push({name: 'ranking', query: {category: category.key}})
}

export function navigateToDApp (dapp) {
  router.push({name: 'dapp', params: {dapp: dapp.key}})
}

export function navigateToHome () {
  router.push({name: 'index'})
}

export function navigateToRanking () {
  router.push({name: 'ranking'})
}

export function navigateToSubmit () {
  window.open(constants.urls.submitForm, '_blank')
  // router.push({name: 'submit'})
}

export function navigateToAbout () {
  router.push({name: 'about'})
}

export function navigateToBlog () {
  window.open(constants.urls.blog, '_blank')
}

export function navigateToSearch (keywords) {
  if (keywords) {
    if (currentRoute().name === 'search') { // 搜索页
      replaceQuery({keywords: keywords})
    } else { // 其他页
      router.push({name: 'search', query: {keywords: keywords}})
    }
  } else {
    router.push({name: 'search'})
  }
}

export function replaceQuery (replace) {
  let route = currentRoute()
  return router.push({
    path: route.path,
    query: Object.assign({}, route.query, replace)
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js